function getPageURL(data, language) {
	return data.nodes.filter(element => element.language.code === language)[0].uri;
}

export default getPageURL;